// src/pages/EssentiaExperience.js
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import LogoExperience from "../../assets/img/experience/essentia-experience.svg";
import EssentiaExperience from "../../assets/img/experience/title-essentia-experience.svg";
import ImagemEssentiaExperience from "../../assets/img/experience/ImagemEssentiaExperience.jpg";
import ImagemEssentiaExperience_mobile from "../../assets/img/experience/ImagemEssentiaExperience-mobile.jpg";
import AuditoriumEssentia from "../../assets/img/experience/title-auditorium-essentia.svg";
import ImagemAuditorium from "../../assets/img/experience/ImagemAuditorium.jpg";
import ImagemAuditorium_mobile from "../../assets/img/experience/ImagemAuditorium-mobile.jpg";
import HealthbarEssentia from "../../assets/img/experience/title-healthbar-essentia.svg";
import ImagemHealthbar from "../../assets/img/experience/ImagemHealthbar.jpg";
import ImagemHealthbar_mobile from "../../assets/img/experience/ImagemHealthbar-mobile.jpg";
import Imagem01 from "../../assets/img/experience/img-our-essence-01.jpg";
import Imagem01_mobile from "../../assets/img/experience/img-our-essence-01-mobile.jpg";
import Imagem02 from "../../assets/img/experience/img-our-essence-02.jpg";
import Imagem03 from "../../assets/img/experience/img-our-essence-03.jpg";
import "./EssentiaExperience.scss";

const EssentialExperience = () => {
  const { t } = useTranslation();
  // const [videoSources, setVideoSources] = useState({
  //   mp4: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/background-essentia-experience.mp4",
  //   webm: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/background-essentia-experience.webm",
  // });
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = $(window).scrollTop();
      const scaleFactor = window.innerWidth > 768 ? 0.15 : 0.05;
      $(".anime01").css(
        "transform",
        `translateY(${scrollTop * scaleFactor}px)`,
      );
    };

    // const updateVideoSource = () => {
    //   if (window.innerWidth <= 768) {
    //     // Dispositivo móvel
    //     setVideoSources({
    //       mp4: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/back-mobile.mp4",
    //       webm: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/back-mobile.webm",
    //     });
    //   } else {
    //     // Desktop
    //     setVideoSources({
    //       mp4: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/background-essentia-experience.mp4",
    //       webm: "https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/background-essentia-experience.webm",
    //     });
    //   }
    // };

    //updateVideoSource();
    $(window).on("scroll", handleScroll);
    //window.addEventListener("resize", updateVideoSource);
    return () => {
      $(window).off("scroll", handleScroll);
      //window.removeEventListener("resize", updateVideoSource);
    };
  }, []);
  return (
    <div>
      <div className="back01-02 experiencePage">
        <div className="section01">
          <video
            className="bg_video responsive-video desktop"
            autoPlay
            muted
            loop
            width="100%"
          >
            <source
              src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/background-essentia-experience.mp4"
              type="video/mp4"
            />
          </video>
          <video
            className="bg_video responsive-video mobile"
            playsInline
            autoPlay
            muted
            loop
            width="100%"
          >
            <source
              src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/back-mobile.mp4"
              type="video/mp4"
            />
          </video>
          <div className="blc-container">
            <img src={LogoExperience} alt="Logo Essentia Group" />
            <h1 dangerouslySetInnerHTML={{ __html: t("exp-1") }}></h1>
            <span className="subtitle">SÃO PAULO, SP</span>
            <div className="container">
              <div className="row blc-infos">
                <div className="flex infos">
                  <img
                    src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/clock.svg"
                    alt="Icone Relógio"
                  />
                  <p dangerouslySetInnerHTML={{ __html: t("exp-15") }}></p>
                </div>
                <div className="flex infos with-border">
                  <img
                    src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/house.svg"
                    alt="Icone Casa"
                  />
                  <p dangerouslySetInnerHTML={{ __html: t("exp-13") }}></p>
                </div>
                <div className="flex infos">
                  <img
                    src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/phone.svg"
                    alt="Icone Telefone"
                  />
                  <p dangerouslySetInnerHTML={{ __html: t("exp-14") }}></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section02">
          <picture className="anime01">
            <source
              media="(max-width: 767px)"
              srcSet={Imagem01_mobile}
              type="image/jpeg"
            />
            <source
              media="(min-width: 768px)"
              srcSet={Imagem01}
              type="image/jpeg"
            />
            <img src={Imagem01} alt="Imagem 01" />
          </picture>
          <img className="anime02 desktop" src={Imagem02} alt="Imagem 02" />
          <img className="anime03 desktop" src={Imagem03} alt="Imagem 03" />
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2
                  className="text-uppercase"
                  dangerouslySetInnerHTML={{ __html: t("exp-2") }}
                ></h2>
                <h3>
                  <span dangerouslySetInnerHTML={{ __html: t("exp-3") }}></span>{" "}
                  <br className="desktop" />
                  <span
                    dangerouslySetInnerHTML={{ __html: t("exp-4") }}
                  ></span>{" "}
                  <br className="desktop" />
                  <span
                    dangerouslySetInnerHTML={{ __html: t("exp-5") }}
                  ></span>{" "}
                  <br className="desktop" />
                  <span dangerouslySetInnerHTML={{ __html: t("exp-6") }}></span>
                </h3>
                <p
                  className="txt01"
                  dangerouslySetInnerHTML={{ __html: t("exp-7") }}
                ></p>
                <p
                  className="txt02"
                  dangerouslySetInnerHTML={{ __html: t("exp-8") }}
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section03">
        <div className="letterAnim letter01">
          <div className="animTextBack"></div>
        </div>
        <div className="container">
          <div className="row row01">
            <div className="col-12 col-sm-5 col-sm-offset-1">
              <img src={EssentiaExperience} alt="Essentia Experience" />
              <p
                className="txt01"
                dangerouslySetInnerHTML={{ __html: t("exp-9") }}
              ></p>
            </div>
            <div className="col-12 col-sm-6">
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet={ImagemEssentiaExperience_mobile}
                  type="image/jpeg"
                />
                <source
                  media="(min-width: 768px)"
                  srcSet={ImagemEssentiaExperience}
                  type="image/jpeg"
                />
                <img
                  className="anime04"
                  src={ImagemEssentiaExperience}
                  alt="Imagem Essentia Experience"
                />
              </picture>
            </div>
          </div>
          <div className="row row02">
            <div className="col-12 col-sm-6">
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/img-5-mobile.jpg"
                  type="image/jpeg"
                />
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/img-5.jpg"
                  type="image/jpeg"
                />
                <img
                  className="anime06"
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/essentia-experience/img-5.jpg"
                  alt="Imagem Healthbar Essentia"
                />
              </picture>
            </div>
            <div className="col-12 col-sm-5 col-sm-offset-1">
              <p
                className="txt03"
                dangerouslySetInnerHTML={{ __html: t("exp-10") }}
              ></p>
            </div>
          </div>
          <div className="row row03">
            <div className="col-12 col-sm-5 col-sm-offset-1">
              <img src={AuditoriumEssentia} alt="Auditorium Essentia" />
              <p
                className="txt02"
                dangerouslySetInnerHTML={{ __html: t("exp-11") }}
              ></p>
            </div>
            <div className="col-12 col-sm-6">
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet={ImagemAuditorium_mobile}
                  type="image/jpeg"
                />
                <source
                  media="(min-width: 768px)"
                  srcSet={ImagemAuditorium}
                  type="image/jpeg"
                />
                <img
                  className="anime05"
                  src={ImagemAuditorium}
                  alt="Imagem Auditorium Essentia"
                />
              </picture>
            </div>
          </div>
        </div>
        <div className="letterAnim letter02">
          <div className="animTextBack"></div>
        </div>
      </div>
      <div className="section04">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 dangerouslySetInnerHTML={{ __html: t("exp-12") }}></h2>
              <span className="divisor"></span>
              <p>
                essentiaexperience@essentiagroup.com.br <br />
                <span dangerouslySetInnerHTML={{ __html: t("exp-14") }}></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EssentialExperience;
